/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ads_Per_WeekInputs */

const en_directory_ads_per_week = /** @type {(inputs: Directory_Ads_Per_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/week`)
};

const zh_directory_ads_per_week = /** @type {(inputs: Directory_Ads_Per_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/周`)
};

/**
* | output |
* | --- |
* | "/week" |
*
* @param {Directory_Ads_Per_WeekInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_per_week = /** @type {((inputs?: Directory_Ads_Per_WeekInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Per_WeekInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_per_week(inputs)
	return zh_directory_ads_per_week(inputs)
});
export { directory_ads_per_week as "directory.ads.per_week" }